import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { mockUserPlan } from "./_mock-user-plan";

import { api } from "@/lib/api-client";
import { PlanName } from "@/types/plans";
import { AxiosMock } from "@/utils/mock";

export type PlanConfig = {
  valuation_update_frequency: string;
  valuation_guides: string;
  auction_analytics: boolean;
  ad_listing_analytics: boolean;
  number_of_garages: number;
  cars_per_garage: number;
  garage_risk_kpis: boolean;
};

export type PlanUser = {
  id: string;
  user_id: string;
  name: PlanName;
  created_at: string;
  config: PlanConfig;
};

if (import.meta.env.VITE_APP_MODE === "test") {
  const mock = AxiosMock.getInstance();
  mock.onGet("/carburate/tiers").reply(() => [200, mockUserPlan]);
}

export const getPlansUser = async (): Promise<PlanUser> => {
  return api.get("/carburate/tiers") as Promise<PlanUser>;
};

type UsePlansUserOptions = Omit<
  UseQueryOptions<PlanUser, Error, PlanUser, readonly ["plans"]>,
  "queryKey" | "queryFn"
>;

export const usePlansUser = (config?: UsePlansUserOptions) =>
  useQuery<PlanUser, Error, PlanUser, readonly ["plans"]>({
    queryKey: ["plans"],
    queryFn: getPlansUser,
    // Ensure we refetch when the component mounts or the window regains focus —
    // this is important when users return from an external checkout flow.
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchInterval: 2000,
    ...config,
  });
